import { render, staticRenderFns } from "./Accounts.vue?vue&type=template&id=2a06bc95"
import script from "../services/Accounts.js?vue&type=script&lang=js&external"
export * from "../services/Accounts.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports